<template>
  <div class="terminal">
    <div class="t-top">
      <div class="banner w1200">
        <div class="title T1 mb8">全渠道经营场景</div>
        <p class="T5 mb64">
          覆盖全渠道经营场景，占据每个流量入口，流量变现快速高效
        </p>
        <a target="_blank" class="BigBtnType1" href="/">立即创建体验</a>
      </div>
    </div>
    <div
      :class="`${
        $store.state.sceneClassName === 'app'
          ? 'app_multi-tab'
          : 'multi-tab w1200'
      }`"
    >
      <ul class="multi-tab-ul">
        <li
          :class="`multi-tab-item ${
            activeMenu === 'terminalH5' || !activeMenu ? 'on' : ''
          }`"
        >
          <router-link to="/terminal">
            <i class="iconfont iconicon_h"></i>
            <span>微信H5店铺</span>
          </router-link>
        </li>
        <li
          :class="`multi-tab-item ${activeMenu === 'terminalMini' ? 'on' : ''}`"
        >
          <router-link to="/terminal/mini">
            <i class="iconfont iconicon_minprogram"></i>
            <span>微信小程序</span>
          </router-link>
        </li>
        <li
          :class="`multi-tab-item ${activeMenu === 'terminalPc' ? 'on' : ''}`"
        >
          <router-link to="/terminal/pc">
            <i class="iconfont iconicon_pc1"></i>
            <span>PC端独立官网</span>
          </router-link>
        </li>
        <li
          :class="`multi-tab-item ${activeMenu === 'terminalApp' ? 'on' : ''}`"
        >
          <router-link to="/terminal/app">
            <i class="iconfont iconicon_App"></i>
            <span>App内嵌课堂</span>
          </router-link>
        </li>
      </ul>
    </div>
    <router-view></router-view>
    <v-free
      v-if="$store.state.sceneClassName === 'app'"
      title="让您一分钟拥有<br/>自己的知识店铺"
      href=""
    ></v-free>
    <v-free v-else title="让您一分钟拥有自己的知识店铺" href=""></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';

export default {
  name: 'terminal',
  data() {
    return {
      activeMenu: ''
    };
  },
  components: { 'v-free': Free },
  mounted() {
    this.$store.commit('toggleHeaderClassName', 'whiteNav');
    this.getActiveRoute();
    this.activeMenu = this.$route.name || '';
  },
  watch: {
    $route(to, from) {
      this.activeMenu = to.name || '';
    }
  },
  methods: {
    getActiveRoute() {
      console.log(this.$route);
    }
  }
};
</script>

<style lang="scss">
.terminal {
  .t-top {
    color: #fff;
    background: url('~@/assets/images/terminalBack.jpg') center;
    .banner {
      height: 540px;
      display: flex;
      align-items: baseline;
      justify-content: center;
      flex-direction: column;
      background-position: center;
    }
  }

  .module-box .title {
    font-weight: normal;
  }

  .capacity {
    display: flex;
    justify-content: space-between;
    .function-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon {
        width: 78px;
        height: 78px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #eaf4ff;
        margin-bottom: 14px;
      }
    }
  }
}
.app {
  .terminal {
    padding-top: 1.04rem;
    .t-top {
      height: 6.68rem;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      padding-top: 1.32rem;
      background-image: url('~@/assets/images/terminalBack_app.jpg');
      .banner {
        text-align: center;
        width: auto;
        display: block;
        .title {
          margin-bottom: 0;
          font-size: 0.8rem;
          font-weight: 500;
          letter-spacing: 0.04rem;
          padding: 0.16rem 0 0.38rem;
        }
        p {
          margin-bottom: 0.48rem;
          font-size: 0.28rem;
        }
        .BigBtnType1 {
          height: auto;
          color: #1472ff;
          border-radius: 0.44rem;
          background: #fff;
          padding: 0.14rem 0.64rem;
          border: 0.02rem solid #fff;
          font-size: 0.28rem;
        }
      }
    }
    .app_multi-tab .multi-tab-ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 1.28rem 0.72rem 0.16rem;
      .multi-tab-item a {
        display: block;
        padding: 0.14rem 0.64rem;
        font-size: 0.32rem;
        text-align: center;
        border-radius: 0.44rem;
        margin-bottom: 0.46rem;
        border: 0.02rem solid #1472ff;
        color: #333;
        .iconfont {
          display: none;
        }
      }
      .multi-tab-item.on a {
        border: 0.02rem solid #1472ff;
        background: #1472ff;
        color: #fff;
      }
    }
  }
}
</style>
